import React from "react";
import styles from "./qa.module.css";

const Qa = ({ children, question }) => {
  return (
    <div className={styles.question}>
      <h4>{question}</h4>
      <p>{children}</p>
    </div>
  );
};

export default Qa;
